import { ClientConvertResponse } from "../../infra/api/service/client_api_convert";

export enum Role {
  Role_Unknown = 0,
  Role_Admin = 1,
  Role_Member = 2,
}

// 企業アカウント
export class Client {
  public static from(from: ClientConvertResponse): Client {
    return new Client(
      from.id,
      from.companyID,
      from.name,
      from.nameKana,
      from.gsIconURL,
      from.signedIconURL,
      from.phoneNumber,
      from.department,
      from.position,
      from.email,
      from.createdAt,
      from.role
    );
  }

  public email: string;

  constructor(
    // アカウントID
    public readonly id: string,
    // 企業ID
    public readonly companyID: string,
    // 名前
    public readonly name: string,
    // 名前（ふりがな）
    public readonly nameKana: string,
    // プロフィール画像
    public readonly gsIconURL: string,

    public readonly signedIconURL: string,
    // 電話番号
    public readonly phoneNumber: string,
    // 部署
    public readonly department: string,
    // 役職
    public readonly position: string,
    // メールアドレス // ToDo : Readonlyを外す必要性を再チェック
    email: string,
    // （タイムスタンプ）
    public readonly createdAt: Date,

    public readonly role: Role
  ) {
    this.email = email;
  }

  public getIconURL(): string {
    if (this.signedIconURL) {
      return this.signedIconURL;
    } else {
      return this.gsIconURL;
    }
  }
}



// WEBPACK FOOTER //
// ./src/domain/model/client.ts